import { ExtendedAccountColumns } from '@/backend/features/contact-management/entities/extended-account/types';
import { ExtendedUserDirectoryFilterData } from '@/ui/features/contact-management/UserDIrectoryPanel/types';
import {
    UserDirectoryFilterParams,
    useUserDirectoryFilter,
} from '@juvare/contact-management/ui/features/user-directory/hooks/useUserDirectoryFilter';
import { useOverrideCredentialingUserDirectoryFilter } from '@juvare/credentialing/ui/hooks';
import { Filter } from '@juvare/platform-shared/features/storage';
import React from 'react';

export const useOverrideUserDirectoryFilter = (
    params: UserDirectoryFilterParams,
): {
    data?: Filter<ExtendedAccountColumns>[];
    isLoading: boolean;
    error?: unknown;
} => {
    const { data: accountFilters, error: accountError, isLoading: isAccountLoading } = useUserDirectoryFilter(params);

    const {
        data: credentialingFilters,
        error: credentialingError,
        isLoading: isCredentialingLoading,
    } = useOverrideCredentialingUserDirectoryFilter(params);

    const isLoading = isAccountLoading || isCredentialingLoading;
    const error = accountError || credentialingError;

    const filters = React.useMemo(() => {
        if (isLoading || error) return undefined;

        const filters: Filter<ExtendedAccountColumns>[] = [];

        if (accountFilters?.length) filters.push(...accountFilters);
        if (credentialingFilters?.length) filters.push(...credentialingFilters);

        const filterData = params.filterData as ExtendedUserDirectoryFilterData;
        if (filterData?.stateOfWork) {
            filters.push({ column: 'stateOfWork', op: '=', value: filterData.stateOfWork });
        }

        return filters;
    }, [isLoading, error, accountFilters, credentialingFilters, params.filterData]);

    return { data: filters, isLoading, error };
};
